<template>
  <div class="materialCollection-content">
    <h3 class="left ml10" style="position: relative;">
      我的收藏

      <Course name="Collection" />
    </h3>
    <div style="display:flex">
      <!-- 文章标签管理 -->
      <!-- <el-row> -->
      <!-- <el-col :span="3" style="width:170px"> -->
      <div
        class="materialCollection-content-left"
        style="width:170px;min-width:150px"
      >
        <div class="ml10 left-top">
          <div class="article-tag">文章标签</div>
          <div class="iconfont manageIcon" v-if="!isEdit">&#xe645;</div>
          <div class="manage cursor" @click="manage" v-if="!isEdit">管理</div>
          <!-- <div class="ml10" @click="manage">
            <span class="iconfont">&#xe645;</span>
            <div class="ml5">管理</div>
          </div> -->
          <!-- <div class="clear"></div> -->
        </div>
        <div class="ml10 left-title mr15"></div>
        <div class="ml10 tags left">
          <ul v-if="!isEdit" class="showtag">
            <li
              class="item"
              @click="searchByTag(-999)"
              :class="{ active: this.labelId == -999 }"
            >
              <span>全部({{ allDataCount }})</span>
            </li>
            <li
              v-for="(item, index) in tags"
              :key="item.labelName"
              @click="searchByTag(item.labelId)"
              :class="{
                active: item.labelId == labelId,
                item: !isEdit
              }"
            >
              <span v-if="isEdit" class="editinput">
                <el-input
                  placeholder="标签名"
                  v-model="item.labelName"
                  size="mini"
                  style="width:99px"
                ></el-input>
                <span class="iconfont ml5 close cursor" @click="close(index)"
                  >&#xe632;</span
                >
              </span>
              <span v-if="!isEdit"
                >{{ item.labelName }}({{ item.statCount }})</span
              >
            </li>

            <li v-if="!isEdit" @click="manage" class="cursor">
              <span class="iconfont">&#xe74a;</span
              ><span class="ml5">新建标签</span>
            </li>
          </ul>
          <ul class="edittag" v-if="isEdit">
            <li class="alltag" :class="{ active: this.labelId == -999 }">
              <span>全部({{ allDataCount }})</span>
            </li>
            <li v-for="(item, index) in tags" :key="index">
              <el-input
                placeholder="标签名"
                v-model="item.labelName"
                size="mini"
                style="width:100px"
              ></el-input>
              <span class="iconfont ml5 add cursor" @click="close(index)"
                >&#xe632;</span
              >
            </li>

            <li>
              <el-input
                placeholder="标签名"
                v-model="tagName"
                size="mini"
                style="width:100px"
                @keyup.enter.native="add"
              ></el-input>
              <span class="iconfont ml5 add cursor" @click="add()"
                >&#xe74a;</span
              >
            </li>
            <li>
              <el-button size="mini" round class="confirm" @click="confirm"
                >确认</el-button
              >
              <el-button size="mini" round class="cancel" @click="cancel"
                >取消</el-button
              >
            </li>
          </ul>
        </div>
      </div>
      <!-- </el-col> -->
      <!-- <el-col :span="21"> -->
      <div
        class="materialCollection-content-right clear ml20"
        style="  width: 100%;"
      >
        <div class="material-tabs clear">
          <div class="material-tabs-left fl">
            <span
              class="cursor"
              :class="{ activeTab: activeTab == 'article' }"
              @click="changeType('article')"
              >文章</span
            >
            <span
              class="ml20 cursor"
              :class="{ activeTab: activeTab == 'paragraph' }"
              @click="changeType('paragraph')"
              >段落</span
            >
            <span
              class="ml20 cursor"
              :class="{ activeTab: activeTab == 'picture' }"
              @click="changeType('picture')"
              >图片</span
            >
          </div>
          <div class="material-tabs-right fr">
            最近搜索
            <span class="iconfont" style="font-size:12px">&#xe630;</span>
          </div>
        </div>
        <div class="material-content-box">
          <meaterialarticle
            v-if="activeTab == 'article'"
            ref="article"
          ></meaterialarticle>
          <meaterialparagraph
            v-if="activeTab == 'paragraph'"
            ref="paragraph"
          ></meaterialparagraph>
          <meaterialpicture
            v-if="activeTab == 'picture'"
            ref="picture"
          ></meaterialpicture>
        </div>
      </div>
      <!-- </el-col> -->
      <!-- </el-row> -->
    </div>

    <!-- 设置标签弹窗 -->
    <div class="material-dialog">
      <el-dialog
        :visible.sync="dialogTagVisible"
        top="30vh"
        :center="false"
        width="400px"
        style="border-radius:15px"
      >
        <div slot="title" class="dialog-title">标签设置</div>
        <div class="dialog-tags-info">
          选择标签：({{ detailTag === "" ? 0 : detailTag.split("|").length }}/{{
            tags.length
          }})一篇文章/段落/图片/标签最多可设置3个
        </div>
        <div class="dialog-tags clear">
          <ul>
            <li
              class="ml5 fl cursor"
              v-for="item in tags"
              :key="item.labelName"
              @click="selectTag(item.labelName)"
            >
              <span
                class="labelshow"
                :class="{ labelshowactive: isActiveTag(item.labelName) }"
              >
                {{ item.labelName }}
              </span>
            </li>
          </ul>
        </div>
        <div class="dialog-bottom ml10">
          <el-input
            size="mini"
            placeholder="请输入添加的标签名称"
            v-model="tagName"
            class="dialog-input"
            @keyup.enter.native="tagadd"
          >
          </el-input>
          <el-button size="mini" class="tagadd" @click="tagadd">添加</el-button>
        </div>
        <div slot="footer" class="dialog-footer ml5 center">
          <el-button size="mini" class="dialog-confirm" @click="dialogConfirm"
            >确认设置</el-button
          >
          <el-button size="mini" class="dialog-cancel" @click="dialogCancel"
            >取消</el-button
          >
        </div>
      </el-dialog>
    </div>

    <popoutDetail
      :guid="id"
      :isShow="isShowDetail"
      :type="detailType"
      v-if="isShowDetail"
      ref="popoutdetail"
    >
    </popoutDetail>
  </div>
</template>

<script>
import meaterialarticle from "../views/Material/MeaterialArticle";
import meaterialparagraph from "../views/Material/MaterialParagraph";
import meaterialpicture from "../views/Material/MaterialPicture";
import Course from "@/components/share/Course";
import popoutDetail from "../components/share/popoutDetail";
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  components: {
    meaterialarticle,
    meaterialparagraph,
    meaterialpicture,
    Course,
    popoutDetail
  },
  data() {
    return {
      // dialogTagVisible: false,

      //是否浏览图片
      isShowBrowse: true,
      // detailTag: "",
      isEdit: false,
      activeTag: "",

      tagName: "",
      tagsBak: "",
      activeTab: "article"
      //detailId: 0,
    };
  },
  computed: {
    ...mapState("material", [
      "tags",
      "dialogTagVisible",
      "detailId",
      "detailLableNameList",
      "labelId",
      "isShowDetail",
      "id",
      "detailType",
      "allDataCount"
    ]),

    // ...mapGetters("material", ["statCount"]),
    dialogTagVisible: {
      get() {
        return this.$store.state.material.dialogTagVisible;
      },
      set(val) {
        this.$store.state.material.dialogTagVisible = val;
      }
    },
    detailTag: {
      get() {
        return this.$store.state.material.detailTag;
      },
      set(val) {
        this.$store.state.material.detailTag = val;
      }
    }
  },
  methods: {
    ...mapActions("material", [
      "ALabel",
      "ALabelBind",
      "ALabelInsert",
      "ALabelDel"
    ]),
    ...mapMutations("material", [
      "AsetTags",
      "AUpdateArticleLabelNameList",
      "AUpdateParagraphLabelNameList",
      "AUpdatePictureLabelNameList",
      "AsetlabelId"
    ]),

    manage() {
      this.tagsBak = JSON.stringify(this.tags);
      this.tagName = "";
      this.isEdit = true;
    },
    changeType(type) {
      this.activeTab = type;
      this.isEdit = false;
    },
    async confirm() {
      if (this.tagName) {
        this.add();
      }
      //原始的标签
      var orgTags = JSON.parse(this.tagsBak);
      //新增的
      //var newTags = this.tags.filter((m) => m.labelId == 0);
      var newTagsArray = this.tags.map(m => {
        return m.labelName;
      });

      var orgTagsArray = orgTags.map(m => {
        return m.labelName;
      });
      //原始标签和现有标签共有的
      var sameTagsArray = orgTagsArray.filter(function(v) {
        return newTagsArray.indexOf(v) > -1;
      });
      //需要删除的标签
      var deleteArray = orgTags.filter(m => {
        return !sameTagsArray.includes(m.labelName);
      });
      //新增的
      var newArray = this.tags.filter(m => {
        return !sameTagsArray.includes(m.labelName);
      });
      // console.log("目前有的标签：" + JSON.stringify(newTagsArray));
      // console.log("原始标签：" + JSON.stringify(orgTagsArray));
      // console.log("共有的标签：" + JSON.stringify(sameTagsArray));
      // console.log("需要删除的标签：" + JSON.stringify(deleteArray));
      // console.log("需要新增的标签：" + JSON.stringify(newArray));
      //需要删除的标签：
      if (deleteArray.length > 0) {
        var needDeleteArray = deleteArray.map(m => {
          return m.labelId;
        });
        await this.ALabelDel({ labelIdList: needDeleteArray.join("|") });
      }
      //需要新增的标签：
      if (newArray.length > 0) {
        var needNewArray = newArray.map(m => {
          return m.labelName;
        });
        await this.ALabelInsert({ labelNameList: needNewArray.join("|") });
      }
      this.getTagList();
      this.isEdit = false;
      this.searchByTag(-999);
    },
    cancel() {
      this.AsetTags({
        dataSource: JSON.parse(this.tagsBak),
        allDataCount: this.allDataCount
      });
      this.tagName = "";
      this.isEdit = false;
      this.searchByTag(-999);
    },
    close(index) {
      this.tags.splice(index, 1);
    },
    add() {
      if (!this.tagName) {
        this.$message({
          showClose: true,
          message: "请输入标签名称",
          type: "warning"
        });
        return;
      }
      var _this = this;

      var filterResult = this.tags.filter(m => m.labelName == _this.tagName);
      if (filterResult.length > 0) {
        this.$message({
          showClose: true,
          message: "该标签已存在",
          type: "warning"
        });
        return;
      }

      this.tags.push({ labelId: 0, labelName: this.tagName, statCount: 0 });
      this.tagName = "";
    },
    async tagadd() {
      var _this = this;
      if (_this.tagName) {
        var result = this.tags.filter(m => {
          return m.name == _this.tagName;
        });
        if (result.length > 0) {
          this.$message({
            showClose: true,
            message: "该标签已经存在",
            type: "warning"
          });
          return;
        }

        var _detailTage =
          this.detailTag === "" ? [] : this.detailTag.split("|");
        if (_detailTage.indexOf(name) <= -1) {
          if (_detailTage.length < 3) {
            this.selectTag(_this.tagName);
          }
        }

        var insertResult = await this.ALabelInsert({
          labelNameList: this.tagName
        });
        if (insertResult.errorCode == 0) {
          this.$message({
            message: "新增标签成功",
            type: "success",
            showClose: true
          });
          this.getTagList();
        } else {
          this.$message({
            showClose: true,
            message: "新增标签失败",
            type: "error"
          });
        }
      } else {
        this.$message({
          showClose: true,
          message: "请输入标签",
          type: "warning"
        });
      }
      _this.tagName = "";
    },
    isActiveTag(tag) {
      if (this.detailTag) {
        var result = this.detailTag.split("|").filter(m => {
          return m == tag;
        });
        return result.length > 0;
      }
      return false;
    },
    selectTag(name) {
      var _detailTage = this.detailTag === "" ? [] : this.detailTag.split("|");
      if (_detailTage.indexOf(name) <= -1) {
        if (_detailTage.length >= 3) {
          this.$message({
            showClose: true,
            message: "最多可设置3个",
            type: "warning"
          });
          return;
        }
        _detailTage.push(name);
      } else {
        _detailTage = _detailTage.filter(m => {
          return m != name;
        });
      }
      this.detailTag = _detailTage.join("|");
    },
    //dialog取消操作
    dialogCancel() {
      this.dialogTagVisible = false;
      this.tagName = "";
    },
    async dialogConfirm() {
      var dataType = "resource";

      if (this.activeTab == "paragraph") {
        dataType = "paragraph";
      } else if (this.activeTab == "picture") {
        dataType = "image";
      }

      this.dialogTagVisible = false;
      this.tagName = "";

      var tagArrary = this.tags.filter(m => {
        return this.detailTag.split("|").includes(m.labelName);
      });

      var tagResult = tagArrary.map(m => {
        return m.labelId;
      });
      var bindResult = await this.ALabelBind({
        labelIdList: tagResult.join("|"),
        dataID: this.detailId,
        dataType: dataType
      });

      if (bindResult.errorCode === 0) {
        if (this.activeTab == "paragraph") {
          this.AUpdateParagraphLabelNameList({
            favoriteParagraphId: this.detailId,
            labelNameList: tagArrary
              .map(m => {
                return m.labelName;
              })
              .join("|")
          });
        } else if (this.activeTab == "picture") {
          this.AUpdatePictureLabelNameList({
            favoriteImageId: this.detailId,
            labelNameList: tagArrary
              .map(m => {
                return m.labelName;
              })
              .join("|")
          });
        } else {
          this.AUpdateArticleLabelNameList({
            favoriteResourceId: this.detailId,
            labelNameList: tagArrary
              .map(m => {
                return m.labelName;
              })
              .join("|")
          });
        }
        if (this.id != 0) {
          this.$refs["popoutdetail"].setLabelNameList(
            tagArrary
              .map(m => {
                return m.labelName;
              })
              .join("|")
          );
        }
        this.getTagList();
        this.$message({
          message: "绑定成功",
          type: "success",
          showClose: true
        });
      } else {
        this.$message({
          message: "绑定失败",
          type: "error",
          showClose: true
        });
      }
    },
    //点击文章标签里的标签
    clickTag() {},
    async getTagList() {
      var result = await this.ALabel();
      if (result.errorCode != 0) {
        this.$message({
          showClose: true,
          message: result.errorMess,
          type: "error"
        });
        return;
      }

      if (result.data != null && result.data.dataSource.length > 0) {
        // result.data = this.sortKey(result.data, "statCount");
        result.data.dataSource.sort(this.sortdown("statCount"));
      }
      this.AsetTags(result.data);
    },
    async searchByTag(labelId) {
      await this.AsetlabelId(labelId);
      this.$refs[this.activeTab].getList(1);
    }
    // down(name) {
    //   return function(obj1, obj2) {
    //     let val1 = obj1[name];
    //     let val2 = obj2[name];
    //     return val2 - val1;
    //   };
    // },
    // sortData(a, b) {
    //   return b.statCount - a.statCount;
    // },
  },
  mounted() {
    this.getTagList();
  }
};
</script>

<style lang="less" scoped>
@import "../assets/style/color";
@import "../assets/style/config";
@import "../assets/style/mixin";

.app-course {
  color: #216bed;
  font-size: 14px;
  line-height: 16px;
  float: right;
  margin-right: 0px;
}

.materialCollection-content {
  font-size: 14px;

  .left {
    margin-bottom: 25px;
  }
  // 文章标签以及管理
  .left-top {
    display: flex;
    height: 38px;
    width: 120px;
    .article-tag {
      line-height: 29px;
      // height: 29px;

      // font-size: 12px;
      // font-family: Source Han Sans CN;
      // font-weight: 500;
      // color: rgba(102, 102, 102, 1);

      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: bolder;
      color: rgba(102, 102, 102, 1);
      // line-height: 36px;
      // line-height: 36px;
    }
    .manage {
      line-height: 29px;
      height: 29px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: rgba(102, 102, 102, 1);
      margin-left: 3px;
    }
    .manageIcon {
      line-height: 29px;
      margin-left: 28px;
    }
  }

  .left-title {
    // margin-top: 10px;
    width: 120px;
    border-bottom: 1px solid #dfe6f4;
  }
  .tags .showtag {
    margin-top: 11px;
    li:last-child {
      color: rgba(16, 88, 246, 1);
      margin-top: 5px;
    }
  }
  .tags .showtag li {
    font-size: 12px;
    line-height: 1.5em;
    padding: 5px 0;
    padding-left: 8px;
    width: 120px;
    height: 28px;
    margin-bottom: 4px;
  }
  .tags .showtag li.item:hover {
    background-color: #e6eef9;
    cursor: pointer;
    background: rgba(232, 238, 250, 1);
    border-radius: 4px;
  }
  .tags .showtag li.item.active {
    background-color: #e6eef9;
    cursor: pointer;
    color: rgba(16, 88, 246, 1);
  }
  .tags {
    .edittag {
      .alltag {
        // height: 14px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 300;
        color: rgba(102, 102, 102, 1);
        line-height: 36px;
        margin-left: 8px;
      }
      //height: 32px;
      margin-top: 7px;
      li {
        height: 36px;
      }
      li:last-child {
        margin-top: 10px;
      }
    }
  }
}

// 文章标签div
.materialCollection-content-left {
  width: 170px;
  border-right: 1px solid #dde4f4;
}

//tabs
.materialCollection-content-right .material-tabs {
  height: 38px;
  border-bottom: 1px solid #dfe6f4;
}
.materialCollection-content-right .material-tabs-left {
  padding-top: 4px;
  height: 38px;
}

.materialCollection-content-right .material-tabs .activeTab {
  color: @theme-color;
  padding: 13px 0;
  border-bottom: 2px solid @theme-color;
}
.materialCollection-content-right .material-content-box {
  padding-top: 12px;
}
//最近搜索
.material-tabs-right {
  font-size: 12px;
  color: @color999;
}
//管理状态下
.materialCollection-content {
  .confirm {
    background: rgba(16, 88, 246, 1);
    color: white;
    border: 0;
  }
  .cancel {
    background-color: #b0b0b0;
    color: white;
    border: 0;
  }
}

// 标签设置弹窗
.material-dialog .dialog-title {
  text-align: left;
}
.material-dialog {
  .dialog-tags {
    margin-top: 15px;
  }
  .dialog-tags-info {
    text-align: left;
    margin-left: 11px;
  }
}
.material-dialog .dialog-bottom {
  margin-top: 10px;
  display: flex;
}
.material-dialog .dialog-bottom .tagadd {
  background-color: @theme-color;
  color: white;
  border-radius: 0;
  border-left: none;
  border-radius: 0 15px 15px 0;
}
.material-dialog .dialog-confirm {
  background-color: @theme-color;
  color: white;
  border-radius: 22px;
  line-height: 1.5em;
}
.material-dialog .dialog-cancel {
  background-color: #e2e2e2;
  border-radius: 22px;
  line-height: 1.5em;
}
.material-dialog .dialog-tags ul li {
  // border-radius: 15px;
  // border: 1px solid #d8d8d8;
  // padding: 2px 10px;
  margin: 5px;
}
// .material-dialog .dialog-tags .tagactive {
//   background-color: white;
//   border: 1px solid #999;
//   padding: 3px 10px;
//   color: #868686;
// }
</style>
<style lang="less">
// 标签设置弹窗
.material-dialog .el-dialog__header {
  padding: 15px;
  border-bottom: 1px solid #f4f4f4;
}
.material-dialog .el-dialog__body {
  padding: 5px;
}
.material-dialog .el-dialog__headerbtn {
  top: 14px;
}
.material-dialog .dialog-bottom .dialog-input .el-input__inner {
  width: 100%;
  border-radius: 0;
  border-radius: 15px 0 0 15px;
}
.material-dialog .dialog-bottom .el-input {
  width: 40%;
}
.material-dialog .el-dialog__footer {
  padding: 30px 20px 20px;
}
.label[data-v-85a1cce2] {
  background: #f2921a;
  border-radius: 15px;
  font-size: 12px;
  color: #ffffff;
  line-height: 18px;
  padding: 1px 6px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -ms-flex-line-pack: center;
  align-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
</style>
